import {
  QuantityInputMaxLength,
  QuantityInputMaxLengthForThirdPartyBrands,
  SingleQuantityInputMaxValue,
  SingleQuantityInputMaxValueForThirdPartyBrands,
} from '../../../../utils/constants';
import React, { useState } from 'react';

import NumericInput from 'react-numeric-input2';
import PropTypes from 'prop-types';
import { isInternalBrand } from '../../../../main/selectors';
import styles from './QuantityNumericInput.scss';
import { useDebouncedCallback } from 'use-debounce';
import { useSelector } from 'react-redux';

const QuantityNumericInput = React.forwardRef(
  ({ isInvalid = false, min = 0, quantityKey, step = 1, value, onBlur, onChange, onPressEnter, ...rest }, ref) => {
    const [focused, setFocused] = useState(false);

    const internalBrand = useSelector(isInternalBrand);
    const maxLength = internalBrand ? QuantityInputMaxLength : QuantityInputMaxLengthForThirdPartyBrands;
    const maxValue = internalBrand ? SingleQuantityInputMaxValue : SingleQuantityInputMaxValueForThirdPartyBrands;

    const selected = false; // value > 0;
    const className = `${styles['quantity-numeric-input']}${selected ? ` ${styles['selected']}` : ''}${
      isInvalid ? ` ${styles['invalid']}` : ''
    } form-control`;

    const style = {
      'input.mobile': {
        borderRadius: '8px',
        lineHeight: 'normal',
        padding: '8px 32px',
      },

      btn: {
        background: 'rgba(0,0,0,0)',
        cursor: 'pointer',
      },

      'btnDown.mobile': {
        borderRadius: '8px 0 0 8px',
        borderWidth: 0,
        bottom: 2,
        left: 2,
        top: 2,
        width: '32px',
      },

      'btnUp.mobile': {
        borderRadius: '0 8px 8px 0',
        borderWidth: 0,
        bottom: 2,
        right: 2,
        top: 2,
        width: '32px',
      },

      'btn:hover': {
        background: 'rgba(240,240,240,1)',
      },

      'btn:active': {
        background: 'rgba(0,0,0,.1)',
      },
    };

    const debouncedSelect = useDebouncedCallback(() => {
      if (!!ref && !!ref.current) {
        ref.current.select();
      }
    }, 50);

    const handleBlur = () => {
      setFocused(false);
      if (!!onBlur && typeof onBlur === 'function') {
        onBlur();
      }
    };

    const handleChange = (val) => {
      !!quantityKey && !!quantityKey.trim() ? onChange(quantityKey, val) : onChange(val);
    };

    const handleFocus = () => {
      setFocused(true);
      debouncedSelect();
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        if (!!onPressEnter && typeof onPressEnter === 'function') {
          onPressEnter(e);
        }
      }
    };

    return (
      <NumericInput
        {...rest}
        autoComplete="off"
        autoCorrect="off"
        className={className}
        max={maxValue}
        maxLength={maxLength}
        min={min}
        mobile
        placeholder={focused ? '' : '0'}
        ref={(node) => {
          if (!!ref && !!node && !!node.refsInput) {
            ref.current = node.refsInput;
          }
        }}
        spellCheck={false}
        step={step}
        strict
        style={focused || selected ? style : false}
        value={value === 0 ? '' : value}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
      />
    );
  }
);

QuantityNumericInput.propTypes = {
  isInvalid: PropTypes.bool,
  min: PropTypes.number,
  quantityKey: PropTypes.string,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onPressEnter: PropTypes.func,
};

export default QuantityNumericInput;
